import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'components/rich/tooltip';

import withPlaceholderStyle, { getRelativeX, getRelativeY } from '.';
import { Button } from '../base';

const ELEMENT = {
  LINE: 'line',
  RECTANGLE: 'rectangle',
};

const VectorPlaceholder = ({ style, ...props }) => {
  const { element } = props.placeholder;

  if (element === ELEMENT.LINE) {
    let children;

    const backgroundColor = props.placeholder.border?.color || props.placeholder.color;

    if (props.placeholder.points) {
      // TODO style
      const { points } = props.placeholder;
      if (points.length !== 2 && points[0].length !== 2 && points[1].length !== 2) {
        return null;
      }

      const [[aX, aY], [bX, bY]] = props.placeholder.points;

      const deltaX = Math.abs(bX - aX) / props.page.size.width;
      const deltaY = Math.abs(bY - aY) / props.page.size.width;

      const lineAngle = (Math.atan2(bY - aY, bX - aX) * 180) / Math.PI;
      const lineLength = Math.sqrt(deltaX ** 2 + deltaY ** 2);
      const lineThickness = props.placeholder.border?.thickness || 1;

      const left = getRelativeX(aX, props.page.size.width);
      const top = getRelativeY(aY, props.page.size.height);
      const height = lineThickness * props.pageSizeScale;

      return (
        <div
          style={{
            left: `${left * 100}%`,
            top: `calc(${top * 100}% - ${height / 2}px)`,
            width: `${lineLength * 100}%`,
            height,
            transform: `rotate(${lineAngle}deg)`,
            transformOrigin: `0% 50%`,
            backgroundColor,
          }}
          className={classNames({
            'editor-placeholder': true,
            'editor-placeholder-vector': true,
            'editor-placeholder-vector-interactive': props.interactive,
          })}
        />
      );
    }

    if (props.placeholder.frame) {
      children = (
        <div
          style={{ ...style, backgroundColor }}
          className={classNames({
            'editor-placeholder': true,
            'editor-placeholder-vector': true,
            'editor-placeholder-vector-interactive': props.interactive,
          })}
        />
      );
    }

    if (props.interactive) {
      const handleOnRemoveClick = e => {
        e.preventDefault();

        props.onRemove(props.placeholder);
      };

      return (
        <Tooltip
          node={
            <>
              <Button variant="inverse" onClick={handleOnRemoveClick}>
                Remove Line
              </Button>
            </>
          }
        >
          {children}
        </Tooltip>
      );
    }

    return children;
  }

  if (element === ELEMENT.RECTANGLE) {
    const backgroundColor = props.placeholder.color;

    return (
      <div
        style={{ ...style, backgroundColor }}
        className={classNames({
          'editor-placeholder': true,
          'editor-placeholder-vector': true,
        })}
      />
    );
  }

  return null;
};

VectorPlaceholder.propTypes = {
  style: PropTypes.object.isRequired,
  placeholder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  pageSizeScale: PropTypes.number,
  interactive: PropTypes.bool,
  onRemove: PropTypes.func,
};

VectorPlaceholder.defaultProps = {
  pageSizeScale: 1,
  interactive: false,
};

export default withPlaceholderStyle(VectorPlaceholder);
